module.exports = __webpack_public_path__ + "img/sadist_of_notre_dame_mobile.0602fc49.jpg";